// src/components/Icon.js
import React from "react";
import { useNavigate } from 'react-router-dom';
import '../../src/style.css';
const Icon = ({ icon, label, link }) => {


  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };
  return (

    // <div className="insurance-grid mb-4 text-center">
    //         <div className="insurance-icon-container mb-2">
    //           <img src={icon} alt={label} className="insurance-icon" />
    //         </div>
    //         <p className="insurance-name">{label}</p>
    //       </div>

<div className="custom-card mb-2" onClick={handleClick} style={{padding:'6px'}}>
<div className="row align-items-center">
<div className="col-12 text-center">
    <div className="card-body">
      <p className="card-title" style={{fontSize:'16px', display:'block'}}>{label}</p>
    </div>
  </div>
  <div className="col-12 text-end d-flex justify-content-center">
    <img src={icon} className="card-img-top" alt={label} />
  </div>

</div>
</div>
  );
};

export default Icon;
